import React from "react";
import { SectionQuestionAnswers } from "./SectionQuestionAnswers";
import { AdminNotes } from "./AdminNotes";
import Layout from "Layout";
import { ReportHeader } from "Layout/ReportHeader";
import styles from './styles.module.scss';
import { ReportTimeline } from './ReportTimeline';
import { SurvivorInfo } from "./SurvivorInfo";
import { Section } from "./Section";
import { SetReportStatus } from "./SetReportStatus";
import { SurvivorNotes } from "./SurvivorNotes";
import { useHasPermission } from "hooks/useHasPermission";
import { Permissions } from "actions/roleActions";
import { useLocation, useParams } from "react-router-dom";
import {
  usePopulateReportUserNotesAnswers,
  useReportPopulateNeedsFreshData,
} from "hooks/usePopulateReportUserNotesAnswers";
import { FormattedMessage } from "react-intl";
export const Report = () => {

  const hasPermission = useHasPermission();
  const location = useLocation() as { state?: { getNotes?: boolean } };

  const { reportId } = useParams<{ reportId: string }>();
  const getNotes = location.state?.getNotes ?? true;
  const needsFreshData = useReportPopulateNeedsFreshData(reportId ?? null, getNotes);

  const { reportUserNotesAnswers, refetch } = usePopulateReportUserNotesAnswers({
    reportId: reportId ?? null,
    getNotes,
    enabled: needsFreshData,
    resetBeforePopulate: true,
  });

  const updateReport = () => {
    if (reportId) {
      void refetch();
    }
  };
  return (
    <Layout>
      {hasPermission(Permissions.ViewReportDetails, reportUserNotesAnswers.report)
        &&
        <div className={styles.reportData}>

          <div className={styles.middle}>
            <ReportHeader/>

            {hasPermission(Permissions.ManageReportStatus, reportUserNotesAnswers.report) && (
              <SetReportStatus />
            )}
            <Section sectionKey="survivorInformation" className={styles.survivorInformation}>
              <SurvivorInfo/>
            </Section>

            <SectionQuestionAnswers/>

            {hasPermission(Permissions.ViewReportNotes, reportUserNotesAnswers.report) && (
              <Section sectionKey="reportUpdates" className={styles.reportUpdates}>
                <SurvivorNotes/>
              </Section>
            )}
          </div>

          <div className={styles.right}>
            <ReportTimeline/>

            {hasPermission(Permissions.AddReportNotes, reportUserNotesAnswers.report) && (
              <AdminNotes updateReport={updateReport}/>
            )}

            {(!hasPermission(Permissions.ViewReportNotes, reportUserNotesAnswers.report) && !hasPermission(Permissions.AddReportNotes, reportUserNotesAnswers.report)) && (
              <p className={styles.noTimelineMessage}>
                <FormattedMessage id="reports.noTimelineMessage" defaultMessage="You do not have permission to view the report timeline" />
              </p>
            )}
          </div>
        </div>
      }
    </Layout>
  );
}
